import React from "react";
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { FaClock, FaUserMd } from "react-icons/fa";

const data = [
    { name: "Jan", patients: 120, growth: 5 },
    { name: "Feb", patients: 98, growth: 8 },
    { name: "Mar", patients: 150, growth: 12 },
    { name: "Apr", patients: 130, growth: 10 },
    { name: "May", patients: 170, growth: 15 },
    { name: "Jun", patients: 200, growth: 18 },
];

const appointmentData = [
    { name: "Completed", value: 60 },
    { name: "Pending", value: 25 },
    { name: "Cancelled", value: 15 },
];

const COLORS = ["#2a627a", "#FF9800", "#F44336"];

export default function Analytics() {
    return (
        // <div className="min-h-screen p-6 bg-gradient-to-l from-[#78ffa5] to-[#03ab3b] text-gray-900">
        <div className="min-h-screen p-6 bg-white text-gray-900">
            <div className="text-center mb-10">
                <h1 className="text-[35px] font-extrabold bg-[#2a627a] bg-clip-text text-transparent">
                    Healthcare Analytics 
                </h1>
                <p className="text-gray-800 text-[15px] font-semibold mt-2">Your comprehensive overview of healthcare operations</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {/* Total Patients Per Month Chart */}
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Total Patients Per Month</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={data}>
                            <XAxis dataKey="name" stroke="#2a627a" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="patients" fill="#2a627a" radius={[5, 5, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* Patient Growth Chart */}
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Patient Growth</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={data}>
                            <XAxis dataKey="name" stroke="#2a627a" />
                            <YAxis />
                            <Tooltip />
                            <Line type="monotone" dataKey="growth" stroke="#2a627a" strokeWidth={3} dot={{ fill: '#2a627a', r: 5 }} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                {/* Appointments Overview (Pie Chart) */}
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Appointments Overview</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie data={appointmentData} cx="50%" cy="50%" outerRadius={100} label>
                                {appointmentData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Additional Insights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 mt-8">
                {/* Average Treatment Time */}
                <div className="bg-white p-6 rounded-2xl shadow-lg flex items-center gap-4 border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <FaClock className="text-[#2a627a] text-4xl" />
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800">Average Treatment Time</h3>
                        <p className="text-2xl font-bold text-[#2a627a]">45 min</p>
                    </div>
                </div>

                {/* Active Doctors */}
                <div className="bg-white p-6 rounded-2xl shadow-lg flex items-center gap-4 border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <FaUserMd className="text-[#2a627a] text-4xl" />
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800">Active Doctors</h3>
                        <p className="text-2xl font-bold text-[#2a627a]">120</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
